var viewmodelHelpers = require("../helpers/viewmodels")

/**
* Abstract View Model that serves as a basis for other derived View Models
* and provides common functionality across all View Models
*
* @constructor AbstractViewModel
*/
var AbstractViewModel = function (parent) {
  var self = this;

  self.parent = parent;

  self.isDebugMode = function () {
    return (self.getQueryParam('debug') === 'true')
  };

	/**
	 * This method creates a subscription (observable) in a ViewModel that
	 * is derived from a KnockoutJS observable variable contained in another
	 * object.
	 *
	 * @method dependentObservable
	 * @param {String} sParamName The name of the observable value to subscribe to
	 * @param {Object} oDependentObject An object containing the observable
	 * @returns {ObservedVariable} Returns a reference to the observed variable
	 *                            contained by the dependent object
	 */
  self.dependentObservable = function (sParamName, oDependentObject) {
    return ko.computed(function () {
      return (oDependentObject[sParamName]) ? oDependentObject[sParamName]() : null;
    });
  };


	/**
	 * Converts the provided val to a Boolean, or Null
	 *
	 * @method parseBoolean
	 * @param {Mixed} val
	 * @returns {Boolean | Null}
	 */
  self.parseBoolean = function (val) {
    if (val === true || (typeof val === 'string' && val.toLowerCase() === 'true')) {
      return true;
    }
    else if (val === false || (typeof val === 'string' && val.toLowerCase() === 'false')) {
      return false;
    }

    return null;
  };


	/**
	 * Converts a provided string into a Date object
	 *
	 * @method parseDate
	 * @param {String} sDateString
	 * @returns {Date | Null}
	 */
  self.parseDate = function (sDateString) {
    // Parse the provided string into an epoch timestamp
    var sTimeStamp = Date.parse(sDateString);

    // If the date could not be parsed, return null
    if (isNaN(sTimeStamp)) {
      return null;
    }

    // Otherwise, return a new Date object, keyed from that epoch time
    return new Date(sTimeStamp);
  };


	/**
	 * Interprets a value and converts it to Boolean, Number or String
   * based on content
	 *
	 * @method parseValue
	 * @param {Mixed} val
	 * @return {Mixed}
	 */
  self.parseValue = function (val) {
    // Create a numeric value from the passed parameter
    var num = Number(val);

    // If the value is 'true' or 'false', parse it as a Boolean and return it
    if (val.toLowerCase() === 'true' || val.toLowerCase() === 'false') {
      return (val.toLowerCase() === 'true') ? true : false;
    }

    // If the num parsed to a Number, return the numeric value
    // Else if the valuse passed has no length (an attribute without value) return null,
    // Else return the param as is
    return (isNaN(num)) ? val : (val.length === 0) ? null : num;
  };

  return self;
};


/**
 * Resets the View Model properties to their default state
 *
 * @method reset
 * @returns none
 */
AbstractViewModel.prototype.reset = function () {
  // null
}

AbstractViewModel.prototype.conlog = viewmodelHelpers.conlog;
AbstractViewModel.prototype.getQueryParam = viewmodelHelpers.getQueryParam;

module.exports = AbstractViewModel
